import React from 'react';
import { Navbar } from '../components/Navbar';
import { StickyFooter } from '../components/StickyFooter';
import { ServiceHero } from '../components/ServiceHero';
import { ServiceContactForm } from '../components/ServiceContactForm';
import { CheckCircleIcon } from 'lucide-react';
export function RegisteredNurses() {
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-1169">
      <Navbar data-id="element-1170" />
      <main className="flex-1" data-id="element-1171">
        <ServiceHero badge="Services" title="Registered Nurses (RN)" subtitle="Highly skilled Registered Nurses for complex care, acute settings, and clinical leadership." imageUrl="https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=1600&auto=format&fit=crop" data-id="element-1172" />

        <div className="max-w-4xl mx-auto px-4 py-16 lg:py-24" data-id="element-1173">
          <div className="prose prose-lg max-w-none text-text-muted leading-relaxed space-y-6" data-id="element-1174">
            <p data-id="element-1175">
              Our Registered Nurses (RNs) bring extensive clinical expertise and
              leadership to your facility. They are equipped to handle complex
              patient care, administer medications, manage care plans, and
              provide critical oversight.
            </p>
            <p data-id="element-1176">
              Every RN on the Care Nomad platform is fully vetted, with verified
              CNO/CARNA/BCCNM registration, reference checks, and clinical
              competency assessments. We ensure you get the right nurse for your
              specific needs, whether it's for an ICU, ER, or long-term care
              setting.
            </p>
          </div>

          <div className="mt-12 bg-gray-50 rounded-2xl p-8 border border-gray-100" data-id="element-1177">
            <h3 className="text-2xl font-bold text-text-dark mb-6" data-id="element-1178">
              RN Capabilities & Expertise
            </h3>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1179">
              {['Complex patient care & acute setting expertise', 'Verified CNO/CARNA/BCCNM registration', 'Medication administration & IV therapy', 'Care plan management & clinical oversight', 'Experience in ICU, ER, and specialized units', 'Rigorous clinical competency assessments'].map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-1180">
                  <CheckCircleIcon className="w-6 h-6 text-accent-teal flex-shrink-0 mt-0.5" data-id="element-1181" />
                  <span className="text-text-dark font-medium" data-id="element-1182">{feature}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <ServiceContactForm serviceName="Registered Nurses (RN)" data-id="element-1183" />
      </main>
      <StickyFooter data-id="element-1184" />
    </div>;
}